import Vue from 'vue'
import App from './App.vue'

//导入全局配置
import globalConfig from '@/config/globle.config'
window.globalConfig = globalConfig

// 封装日期
import moment from 'moment'
Vue.filter('date', (val, format) => {
  return moment(val).format(format)
})

//ant-design-vue加载进去
import '@/core/lazyAntDesignVue'

import '@/core/lazyImage'

Vue.config.productionTip = false

//引入vue-ls
import Storage from 'vue-ls'
const options = {
  namespace: 'vuejs__', // key键前缀
  name: 'ls', // 命名Vue变量.[ls]或this.[$ls],
  storage: 'session', // 存储名称: session, local, memory
}
Vue.use(Storage, options)

//路由文件
import router from '@/router'

//全局sass文件
import '@/config/main.scss'

//vuex
import store from '@/vuex'

//全局过滤器
import '@/filters/commonFilter'

//引入utils
import utils from '@/utils'
window.utils = utils

//图片加载失败显示的默认图片方法，调用方式<img :src="" @error="errorLoadImg"/>
Vue.prototype.errorLoadImg = function (event) {
  event.target.src = '/logo.png'
}

//图表
import Viser from 'viser-vue'
Vue.use(Viser)

// 创建 EventBus
Vue.prototype.$eventBus = new Vue()

window.version = new Date().getTime()

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0)
})

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')
